import { createSelector } from "reselect";
import get from "lodash/get";

const selectState = (state) => state.invoices;

export const getInvoices = createSelector(selectState, (invoice) => ({
  invoicesList: get(invoice, "invoiceList", []),
  totalCount: get(invoice, "totalCount", 0),
  loading: get(invoice, "loading", false),
}));

export const getInvoiceData = createSelector(selectState, (invoice) =>
  get(invoice, "invoiceData", null)
);

export const getInvoiceStatusOptions = createSelector(
  (state) => state.invoice_status,
  (invoice_status) => {
    return {
      status: get(invoice_status, "invoice_statusList", []).map(
        (status) => status.statusName
      ),
      statusId: get(invoice_status, "invoice_statusList", []).map((option) => ({
        key: option.invoiceStatusId,
        text: option.statusName,
      })),
    };
  }
);
